// extracted by mini-css-extract-plugin
module.exports = {"switcherWrapper":"switcher_switcherWrapper__QYuvJ"};